<template>
  <div class="mainContainer" v-if="from && !from.includes('sousuo')">
    <div class="crumbsList">
      <div v-for="(item,index) in crumbsList" class="box" :key="index">
        <nuxt-link :to="item.path === '/zhuanti' ? 'javascript:void(0)' : item.path" class="crumb">{{item.name}}</nuxt-link>
        <div style="padding: 3px 0;" v-if="index+1 < crumbsList.length && item.name">
          <img src="../assets/images/pages/index/chevron-right.png" alt="">
        </div>
      </div>
      <div class="box" v-if="defaultName">
        <div style="padding: 3px 0;">
          <img src="../assets/images/pages/index/chevron-right.png" alt="">
        </div>
        <a href="javascript:void(0)" class="crumb">{{defaultName}}</a>
      </div>
      <div class="box" v-if="zhauntiName">
        <nuxt-link :to="from" class="crumb">{{zhauntiName}}</nuxt-link>
      </div>

      <!-- <div class="crumb">{{'详情'}}</div> -->
    </div>
  </div>
</template>

<script setup>
const Route = useRoute()

const from = ref(Route.query.from)
const defaultName = ref("")
const zhauntiName = ref("")
const path2Name = {
  '': '首页',
  'xwxq': '新闻资讯',
  'xwzx': '新闻中心',
  'lqxw': '路桥新闻',
  'hyxw': '行业新闻',
  'gjzc': '国家政策',
  'gywm': '关于我们',
  'lqqx': '路桥旗下',
  'ywtx': '业务体系',
  'gcjs': '工程建设',
  'kjwh': '科教文化',
  'zbyz': '资本运作',
  'csfz': '城市发展',
  'rlzy': '人力资源',
  'rczl': '人才战略',
  'rcdw': '人才队伍',
  'rccx': '人才创新',
  'jypx': '教育培训',
  'xxgk': '信息公开',
  'rczp': '人才招聘',
  'dqjs': '党群建设',
  'xxgcddesdjs': '学习贯彻党的二十大精神',
  'djll': '党建理论',
  'djdt': '党建动态',
  'dyfc': '党员风采',
  'ljjs': '廉洁建设',
  'zgzj': '职工之家',
  'zhuanti': '专题',
  // 'DangQunJianShe_ErShiDaZhuanTi_43': '二十大专题',
  // 'DangQunJianShe_JueShengSaoHeiChuE_5' : '决胜扫黑除恶',
  'gsgg':'公示公告',
  'tzgg':'通知公告',
}
const crumbsList = ref([]);

const Props = defineProps({
    zhuantiName: {
        type: String,
        default: ''
    }
})


if (Route.query.from) {
    // 剔除http/https, ftp, mailto, tel, javascript, data:
    from.value = from.value.replace(/^mailto:/, '')
    from.value = from.value.replace(/^tel:/, '')
    from.value = from.value.replace(/^javascript:/, '')
    from.value = from.value.replace(/^ftp:/, '')
    from.value = from.value.replace(/^https?:\/\//, '')
    from.value = from.value.replace(/^data:/, '')
    from.value = from.value.replace(/^base64:/, '')
    from.value = from.value.replace(/^#/, '')


  const _from = from.value.split("/")
  _from.forEach((item, index) => {
  let path;
  if (index > 0) {
    let name = path2Name[_from[index]]
    if (item === '') {
      path = '/'
    } else if(item.includes('sousuo')) {
      path = Route.query.from
      path += `&type=${Route.query.type ? Route.query.type : ''}`
      path += `&page=${Route.query.page ? Route.query.page : 1}`
      name = '搜索'
    } else {
      path = index > 1 ? `/${_from[index - 1]}/${item}` :  `/${item}`
    }
    crumbsList.value.push({path, name})
  }
  if (Route.query.default) {
    defaultName.value = Route.query.default
  }
  if (Props.zhuantiName) {
      zhauntiName.value = Props.zhuantiName
  }
  // if (Route.query.zhauntiName) {
  //   zhauntiName.value = Route.query.zhauntiName
  // }
})
}

</script>

<style scoped lang="scss">
.crumbsList{
  display: flex;
  margin-top: 33px;
  flex: auto;
  .box{
    display: flex;
    font-size: 14px;
    line-height: 22px;
    a:hover {
      text-decoration: none;
    }
    .crumb{
      color: rgba(0, 0, 0, 0.4);
    }
    img{
      margin: 0 5px;
    }
  }
  .crumb{
    font-size: 14px;
    line-height: 22px;
  }
}
</style>